import { isEmpty } from 'lodash'
import * as API from '~/ServerAPI'

export const updateSourceMediaRefCountForOldProject = async (project, id) => {
  const assets = project.layers
    .reduce((acc, l) => ([ ...acc, ...l.assets ]), [])
    .filter(a => a.duration)

  if (isEmpty(project.fileIds) && !isEmpty(assets)) {
    try {
      const { data: { references } } = await API.updateProjectFileRefCount(id)
      const updatedFileIds = references?.map(ref => ref.fileId)
      // eslint-disable-next-line no-param-reassign
      project.fileIds = Array.from(new Set([ ...project.fileIds, ...(updatedFileIds ?? []) ]))
    } catch {
      console.error(`Failed to update refCount in source media files for old project ${id} v ${project.version}`)
    }
  }
}
